/**
 *
 * @param isDark 是否是dark模式
 * @param lightColorProp light主题下 颜色
 * @param darkColorProp dark主题下 颜色
 * @returns
 */
export var getThemeColor = function getThemeColor(isDark, lightColor, darkColor) {
  return isDark ? darkColor : lightColor;
};
/**
 * 获取颜色
 * @param theme 包含颜色值的对象
 * @param color 颜色值或 key
 * @returns rgb值 或 color原封不动返回
 */

export var getColor = function getColor(theme, color) {
  return theme[color] || color;
};